import React from "react";
import { useNavigate } from "react-router-dom";
import { createBedType } from "adminApi/RoomSettingApi/RoomSetting";
import { validateForm } from "utils/validation";
import { BedListRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddBedForm from "./Componates/BedForm";
import fields from "../json/BedListFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddBed = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Build initial values from field definitions
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors } = useFormChange(initialValues, BedListRules);

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    // Send plain JSON — no file uploads in this form
    async (formValues) => await createBedType({ data: formValues }),
    (vals) => {
      const err = validateForm(vals, BedListRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Bed created successfully"
  );

  return (
    <>
      {loadingSubmit && <Spinner isSpinner={true} />}
      <AddBedForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Add Bed"
      />
    </>
  );
};

export default AddBed;
